import React, { useEffect, useState } from "react";
import HeaderDropdown from "../../Header/HeaderDropdown/HeaderDropdown";
import News from "../../News/News";
import NewsletterBox from "../../Newsletter/NewsletterBox";
import "./PageLayout.css";
import { Row, Col } from "antd";
import HeaderList from "../../Header/HeaderList/HeaderList";
import { useLocation } from "react-router-dom";

export default function PageLayout(props) {
  const { pathname } = useLocation();
  const [isMixedFeelings, setIsMixedFeelings] = useState(false);


  useEffect(() => {
    const links = document.getElementsByClassName("language-link");
    const pathNameSplit = pathname.split("/");
    setIsMixedFeelings(pathNameSplit.includes("mixed-feelings"));

    let newPathname;
    let currentLanguage;

    if (pathNameSplit[1] === "es" || pathNameSplit[1] === "en") {
      newPathname = pathname.substring(3);
      currentLanguage = pathNameSplit[1];
      document.getElementById("language_IADB").value = pathNameSplit[1];
    } else {
      newPathname = pathname;
      currentLanguage = "es";
      document.getElementById("language_IADB").value = "es";
    }
    if (links.length > 0) {
      const newHRef =
        window.location.origin +
        "/#/" +
        (currentLanguage === "es" ? "en" : "es") +
        newPathname;
      links[1].href = newHRef;

      /* document.getElementsByClassName("is-active")[1].innerHTML =
        currentLanguage === "es" ? "Español" : "English"; */

      document.getElementsByClassName("language-link")[1].innerHTML =
        currentLanguage === "es" ? "English" : "Español";
    }
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={`${isMixedFeelings ? "page-container-mixed-feelings mx-auto" : " page-container"}`}>
      <div className="screen-padding-header large-screen-padding extra-large-screen-padding max-w-[1280px] mx-auto">
        <Row>
          <Col xs={0} xl={24}>
            <HeaderList />
          </Col>
          <Col xs={24} xl={0}>
            <HeaderDropdown />
          </Col>
        </Row>
      </div>
      <div className="content">
        <div className="content screen-padding large-screen-padding extra-large-screen-padding">
          {props.children}
        </div>
        <div className="footer max-w-[1280px] mx-auto">
          <div
            className={
              ((pathname !== "/" || pathname !== "/en/" || pathname !== "/es/" ) ? "order-2 " : null) +
              "footer-news screen-padding-extra extra-large-screen-padding-extra"
            }
          >
            <News />
          </div>
          <div
            className={
              ((pathname !== "/" || pathname !== "/en/" || pathname !== "/es/" ) ? "at-bottom " : null) +
              "footer-newsletter large-screen-padding extra-large-screen-padding"
            }
          >
            <NewsletterBox />
          </div>
        </div>
        <div className="news-canada-box">
          <img
            className="news-canada-img"
            alt={"Canada"}
            src={"/images/canada.png"}
          />
        </div>
      </div>
    </div>
  );
}
